/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContact } from './APIContact';
import {
    APIContactFromJSON,
    APIContactFromJSONTyped,
    APIContactToJSON,
} from './APIContact';

/**
 * 
 * @export
 * @interface APIPaginatedContactList
 */
export interface APIPaginatedContactList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedContactList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedContactList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedContactList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIContact>}
     * @memberof APIPaginatedContactList
     */
    results: Array<APIContact>;
}

/**
 * Check if a given object implements the APIPaginatedContactList interface.
 */
export function instanceOfAPIPaginatedContactList(value: object): value is APIPaginatedContactList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedContactListFromJSON(json: any): APIPaginatedContactList {
    return APIPaginatedContactListFromJSONTyped(json, false);
}

export function APIPaginatedContactListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedContactList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIContactFromJSON)),
    };
}

export function APIPaginatedContactListToJSON(value?: APIPaginatedContactList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIContactToJSON)),
    };
}

